import React, { useRef, useState, useEffect } from 'react';
import { GitHubCalendar } from 'react-github-calendar';
import 'react-github-calendar/tooltips.css';
import { useTheme } from '../context/ThemeContext';
import './GithubActivityChart.css';

const WEEKS = 53;
const BLOCK_MARGIN = 3;
const WEEKDAY_LABEL_WIDTH = 48;
const DESKTOP_BREAKPOINT = 768;

export default function GithubActivityChart({ username }) {
  const { isDark } = useTheme();
  const wrapperRef = useRef(null);
  const [blockSize, setBlockSize] = useState(12);
  const [isDesktop, setIsDesktop] = useState(
    () => typeof window !== 'undefined' && window.innerWidth > DESKTOP_BREAKPOINT
  );

  useEffect(() => {
    const mq = window.matchMedia(`(min-width: ${DESKTOP_BREAKPOINT + 1}px)`);
    const handler = (e) => setIsDesktop(e.matches);
    handler(mq);
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, []);

  useEffect(() => {
    const el = wrapperRef.current;
    if (!el) return;

    const updateBlockSize = () => {
      const width = el.offsetWidth;
      const labelWidth = isDesktop ? WEEKDAY_LABEL_WIDTH : 0;
      const available = width - labelWidth;
      const size = Math.max(8, Math.floor((available + BLOCK_MARGIN) / WEEKS) - BLOCK_MARGIN);
      setBlockSize(size);
    };

    updateBlockSize();
    const observer = new ResizeObserver(updateBlockSize);
    observer.observe(el);
    return () => observer.disconnect();
  }, [isDesktop]);

  if (!username) return null;

  const profileUrl = `https://github.com/${username}`;

  return (
    <section className="github-activity-section" aria-label="GitHub activity">
      <h2 className="column-header">GITHUB ACTIVITY</h2>
      <a
        href={profileUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="github-activity-link"
      >
        <div ref={wrapperRef} className="github-activity-chart-wrapper">
          <GitHubCalendar
            username={username}
            colorScheme={isDark ? 'dark' : 'light'}
            fontSize={11}
            blockSize={blockSize}
            blockMargin={BLOCK_MARGIN}
            showWeekdayLabels={isDesktop ? ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'] : false}
            hideColorLegend
            hideTotalCount
          />
        </div>
      </a>
    </section>
  );
}
